// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"58d8720235a9e7d36cef","264":"2b251399545e4d66f11b","265":"14a6932f659fb4090020","318":"a177440f0b5dec39352c"}[chunkId] + ".chunk.js";
};